import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";

import marcelo from "../../assets/images/time/marcelo.JPG";
import kenia from "../../assets/images/time/kenia.JPG";
import tatiane from "../../assets/images/time/tatiane.JPG";
import rafaeln from "../../assets/images/time/rafaeln.JPG";
import danilo from "../../assets/images/time/danilo.JPG";
import rafaelv from "../../assets/images/time/rafaelv.JPG";
import iasmim from "../../assets/images/time/iasmim.JPG";
import kamilla from "../../assets/images/time/kamilla.JPG";
import ana from "../../assets/images/time/ana.JPG";
import raissa from "../../assets/images/time/raissa.JPG";

const team = [
  {
    nome: "Marcelo Camargos",
    cargo: "Diretor | Assessor de Investimentos - Corretor",
    descricao:
      "Fundou a empresa em 2003. Atua com foco em planejamento financeiro e proteção patrimonial, liderando a equipe com visão estratégica e compromisso com a excelência no atendimento.",
    imagem: marcelo,
  },
  {
    nome: "Kenia Camargos",
    cargo: "Diretora | Especialista em Planos de Saúde - Corretora",
    descricao:
      "Fundadora da empresa em 2003, possui ampla experiência em planos de saúde individuais e empresariais. Atua com foco em soluções personalizadas para clientes e empresas, liderando a equipe com visão estratégica e um forte compromisso com a excelência no atendimento.",
    imagem: kenia,
  },
  {
    nome: "Tatiane Shimada",
    cargo: "Consultora | Especialista em Seguro Auto, Frota e Agrícola",
    descricao:
      "Integrante da Free desde 2003. Atua com foco na gestão de riscos em seguros automotivos, agrícolas e de frota, prezando pelo atendimento técnico e próximo ao cliente.",
    imagem: tatiane,
  },
  {
    nome: "Rafael Neves",
    cargo: "Sinistro | Especialista em Acidentes",
    descricao:
      "Na Free desde 2014. Responsável por acompanhar e orientar os clientes em processos de sinistro, com empatia e agilidade em momentos delicados.",
    imagem: rafaeln,
  },
  {
    nome: "Danilo Silva",
    cargo: "Programador | Desenvolvimento e Análise de Dados",
    descricao:
      "Desde 2021, desenvolve sistemas internos e faz análises de dados para otimizar processos e melhorar a experiência digital dos clientes.",
    imagem: danilo,
  },
  {
    nome: "Rafael Vitor",
    cargo: "Consultor | Especialista em Consórcio e Previdência",
    descricao:
      "Parte da equipe desde 2018. Atua com foco em planejamento de longo prazo, auxiliando clientes a conquistar objetivos como aquisição de bens e aposentadoria segura.",
    imagem: rafaelv,
  },
  {
    nome: "Iasmim Helena",
    cargo: "Consultora | Especialista em Seguro Auto e Vida",
    descricao:
      "Desde 2023, atua no suporte e na gestão de seguros pessoais, com foco em seguro auto e seguro de vida. É reconhecida pela atenção aos detalhes, comprometimento com o cliente e agilidade na entrega de soluções personalizadas.",
    imagem: iasmim,
  },
  {
    nome: "Kamilla Lima",
    cargo: "Consultora | Especialista em Seguro Auto, Vida e Agrícola",
    descricao:
      "Na Free desde 2023. Trabalha com seguros automotivos, proteção de equipamentos agrícolas e planejamento de segurança familiar, com foco em atendimento consultivo.",
    imagem: kamilla,
  },
  {
    nome: "Ana Carla",
    cargo: "Departamento Administrativo | Recepção e Secretariado",
    descricao:
      "Integrante desde 2023. Especialista em atendimento institucional, gestão de agenda e suporte organizacional, garantindo eficiência e acolhimento desde o primeiro contato.",
    imagem: ana,
  },
  {
    nome: "Raissa",
    cargo: "Departamento Administrativo | Cadastro e Documentação",
    descricao:
      "Atua desde 2025. Responsável pela gestão cadastral da empresa, com foco em organização de dados e conformidade documental.",
    imagem: raissa,
  },
];

export default function Team() {
  const [selectedMember, setSelectedMember] = useState(null);
  const sectionRef = useRef(null);
  const containerRef = useRef(null);
  const intervalRef = useRef(null);
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [autoScroll, setAutoScroll] = useState(true);

  // Parar auto-scroll quando o usuário interage
  const stopAutoScroll = () => {
    if (autoScroll) {
      setAutoScroll(false);
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.4 }
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  useEffect(() => {
    if (isVisible && autoScroll) {
      intervalRef.current = setInterval(() => {
        setIndex((prev) => (prev + 4) % team.length);
      }, 3000);
    }

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [isVisible, autoScroll]);

  useEffect(() => {
    const container = containerRef.current;
    const cards = container?.children;
    if (cards && cards[index]) {
      cards[index].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [index]);

  return (
    <section ref={sectionRef} className="pb-10 px-6 max-w-7xl mx-auto">
      <h2 className="text-3xl sm:text-4xl font-bold text-blue-950 mb-4">
        Nossa Equipe
      </h2>
      <p className="text-lg sm:text-xl text-blue-950 mb-8">
        Aquele time preparado para lhe ajudar em todas as etapas <br /> do seu
        seguro ou investimento!
      </p>

      <div
        ref={containerRef}
        className="flex overflow-x-auto overflow-y-hidden gap-6 scrollbar-hide snap-x snap-mandatory pb-4"
        onClick={stopAutoScroll}
        onWheel={stopAutoScroll}
        onTouchStart={stopAutoScroll}
      >
        {team.map((membro, i) => (
          <motion.div
            key={i}
            onClick={() => {
              setSelectedMember(membro);
              stopAutoScroll(); // também garante parada aqui
            }}
            className="min-w-[200px] max-w-xs snap-start bg-white rounded-2xl overflow-hidden shadow hover:shadow-xl transition cursor-pointer flex-shrink-0"
            whileHover={{ scale: 1.05 }}
          >
            <img
              src={membro.imagem}
              alt={membro.nome}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h3 className="font-bold text-gray-800 text-sm uppercase">
                {membro.nome}
              </h3>
              <p className="italic text-gray-500 text-xs mb-2">
                {membro.cargo}
              </p>
              <p className="text-gray-600 text-sm line-clamp-4">
                {membro.descricao}
              </p>
            </div>
          </motion.div>
        ))}
      </div>

      {selectedMember && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm transition-opacity duration-300"
          onClick={() => setSelectedMember(null)}
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            className="relative bg-white rounded-lg w-full max-w-4xl mx-4 md:mx-auto overflow-hidden shadow-xl"
          >
            <button
              onClick={() => setSelectedMember(null)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl"
              aria-label="Fechar"
            >
              ✕
            </button>
            <div className="flex flex-col md:flex-row">
              <div className="md:w-2/3 w-full">
                <img
                  src={selectedMember.imagem}
                  alt={selectedMember.nome}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="md:w-2/3 w-full p-6 overflow-y-auto max-h-[90vh]">
                <h3 className="text-2xl font-bold text-gray-800 mb-1">
                  {selectedMember.nome}
                </h3>
                <p className="italic text-gray-500 text-sm mb-4">
                  {selectedMember.cargo}
                </p>
                <p className="text-gray-700 text-sm leading-relaxed">
                  {selectedMember.descricao}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </section>
  );
}
